<div class="sales-order-custom-field-cell-renderer--container">
  <ng-container
    *ngFor="
      let customFieldValue of customFieldValues | slice: 0 : limit;
      trackBy: trackById
    "
  >
    <mat-chip class="lum-chip mr-1">
      <div
        class="custom-field-chip text-ellipsis"
        matTooltip="
        {{ customFieldValue?.customField?.label }}:
        {{
          customFieldValue?.valueString ||
            customFieldValue?.valueDate ||
            customFieldValue?.valueNumber
        }}
    "
      >
        {{ customFieldValue?.customField?.label }}:
        {{
          customFieldValue?.valueString ||
            customFieldValue?.valueDate ||
            customFieldValue?.valueNumber
        }}
      </div>
    </mat-chip></ng-container
  >

  <!-- Conditionally show 'Show More' or 'Show Less' button -->
  <ng-container *ngIf="customFieldValues && customFieldValues.length > 1">
    <mat-chip
      *ngIf="limit === 1"
      (click)="showMore()"
      class="lum-chip bg-primary text-white"
    >
      <!-- Show remaning items count -->
      +{{ customFieldValues.length - limit }}
    </mat-chip>
    <mat-chip
      *ngIf="limit > 1"
      (click)="showLess()"
      class="lum-chip bg-primary text-white"
    >
      <!-- Show default item count -->
      -{{ limit - 1 }}
    </mat-chip>
  </ng-container>
</div>
